import React from 'react';

const UploadBlob = (props) => {

    return (
        <h1>Upload Blobs</h1>
        )

}

export default UploadBlob;


// WEBPACK FOOTER //
// ./src/components/UploadBlob.js